export const locales = {
  en: require('./en').default
};

export default {
  loginError: '请重新登录',
  noPermission: '无权限请联系管理员',
  '服务端接口连接超时，请检查您当前的网络状态': '服务端接口连接超时，请检查您当前的网络状态',
  '请求错误，请稍后再试': '请求错误，请稍后再试',
  '服务端接口异常，请与平台客服沟通': '服务端接口异常，请与平台客服沟通',
  '数据加载失败，请检查您的浏览器版本或刷新本页面': '数据加载失败，请检查您的浏览器版本或刷新本页面',
  系统错误请联系管理员: '系统错误请联系管理员',
  修改成功: '修改成功',
};
